var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 50,
    viewBox: "0 0 100 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10.889,
    width: 84.001,
    height: 34.2224,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 84.001,
    height: 4.88891,
    fill: "#F8EC8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 45.1111,
    width: 84.001,
    height: 4.88891,
    fill: "#F8EC8B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 10.889,
    width: 5.00006,
    height: 34.2224,
    fill: "#F8EC8B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 10.889,
    width: 5.00006,
    height: 34.2224,
    fill: "#F8EC8B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28.489,
    width: 84.001,
    height: 16.6223,
    fill: "#F8EC8B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 41.2001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73.001,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.002,
    y: 41.2001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 77.002,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 69.001,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 41.2001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 45.001,
    y: 36.3114,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 36.3114,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 81.001,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 77.002,
    y: 36.3114,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 28.999,
    y: 36.3114,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 36.3114,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 41.2001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 20.999,
    y: 13.8223,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13.8223,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 13.8223,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 37.002,
    y: 13.8223,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 69.001,
    y: 13.8223,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 13.8223,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 20.999,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 28.999,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 37.002,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 45.001,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 69.001,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 77.002,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 21.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#F8EC8B"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00098,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 16.999,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 28.999,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 24.999,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 20.999,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 45.001,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 41.002,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 37.002,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 33.002,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 65.001,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 28.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 81.001,
    y: 24.5779,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 32.4,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 11,
    r: 11,
    fill: "#7B7676"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2735 5.47155C88.5707 4.84282 89.4293 4.84281 89.7265 5.47155L91.1415 8.46535L94.3055 8.94543C94.97 9.04625 95.2353 9.89894 94.7545 10.3883L92.4649 12.7187L93.0054 16.0092C93.1189 16.7002 92.4243 17.2272 91.83 16.9009L89 15.3474L86.17 16.9009C85.5757 17.2272 84.8811 16.7002 84.9946 16.0092L85.535 12.7187L83.2455 10.3883C82.7647 9.89894 83.03 9.04625 83.6945 8.94543L86.8585 8.46535L88.2735 5.47155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteYellow);
export default __webpack_public_path__ + "static/media/FavoriteYellow.90a345a08164a5e63f561e2b5d1486a4.svg";
export { ForwardRef as ReactComponent };